<template>
  <v-app v-if="isAuthenticated() && isInitialized">
    <NavigationRail v-if="!LayoutStore.isMobile()" />
    <NavigationBar v-if="LayoutStore.isMobile()" />
    <v-main class="main-container">
      <PageContainer
        :isOpen="NavigationStore.anyOpen()"
        :isCollapsed="NavigationStore.isCollapsed"
      >
        <template v-slot:content>
          <Transition name="fade" mode="out-in">
            <DashboardPage v-if="NavigationStore.items.dashboard" />
            <NewSurveyPage
              v-if="
                NavigationStore.items.create &&
                NavigationStore.shouldShow('items.create')
              "
            />
            <SettingsPage v-if="NavigationStore.items.settings" />
            <ReportPage v-if="NavigationStore.items.reports" />
            <CompanySettingsPage
              v-if="
                NavigationStore.items.company &&
                NavigationStore.shouldShow('items.company')
              "
            />
            <SurveyListPage v-if="NavigationStore.items.surveys" />
          </Transition>
        </template>
      </PageContainer>

      <MapContainer
        :navWidth="NavigationStore.anyOpen() ? 480 : 0"
        v-if="LayoutStore.isMobile() === false"
      />

      <!-- Global notification snackbar -->
      <v-snackbar
        v-model="NotificationStore.show"
        :color="NotificationStore.color"
        :timeout="NotificationStore.timeout"
        bottom
        right
      >
        {{ NotificationStore.message }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="NotificationStore.show = false" aria-label="Dismiss">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-main>
  </v-app>
  <v-app v-else>
    <SplashScreen />
  </v-app>
</template>

<script>
import MapContainer from "@/components/MapContainer.vue";
import NavigationBar from "@/components/navigation/NavigationBar.vue";
import NavigationRail from "@/components/navigation/NavigationRail.vue";
import SplashScreen from "@/components/SplashScreen.vue";

import PageContainer from "@/components/pages/PageContainer.vue";
import DashboardPage from "@/components/pages/DashboardPage.vue";
import NewSurveyPage from "@/components/pages/NewSurveyPage.vue";
import ReportPage from "@/components/pages/ReportPage.vue";
import SettingsPage from "@/components/pages/SettingsPage.vue";
import CompanySettingsPage from "@/components/pages/company/CompanySettingsPage.vue";
import SurveyListPage from "@/components/pages/SurveyListPage.vue";

import { LayoutStore } from "@/stores/LayoutStore.js";
import { NavigationStore } from "@/stores/NavigationStore.js";
import { NotificationStore } from "@/stores/NotificationStore.js";
import { OrgInfoStore } from "@/stores/OrgInfoStore.js";
import { UserInfoStore } from "@/stores/UserInfoStore.js";
import { SurveyStore } from "@/stores/SurveyStore.js";

import { navKeyForPath } from "@/router";

import AuthUtil from "@/util/AuthUtil.js";

export default {
  name: "App",

  components: {
    CompanySettingsPage,
    DashboardPage,
    MapContainer,
    NavigationBar,
    NavigationRail,
    NewSurveyPage,
    PageContainer,
    ReportPage,
    SplashScreen,
    SettingsPage,
    SurveyListPage,
  },

  computed: {
    isInitialized: function () {
      return OrgInfoStore.isInitialized && UserInfoStore.isInitialized;
    },
  },

  data: () => ({
    LayoutStore,
    NavigationStore,
    NotificationStore,
    UserInfoStore,
  }),
  methods: {
    isAuthenticated: function () {
      return AuthUtil.isAuthenticated();
    },
    syncNavFromRoute: function (route) {
      const navKey = navKeyForPath(route.path);
      NavigationStore.setActiveItem(navKey);

      // Deep link into a specific survey: /surveys/:id
      if (route.name === "survey-detail" && route.params.id) {
        const id = route.params.id;
        // Avoid refetching if it's already the open survey.
        if (!SurveyStore.survey || SurveyStore.survey.id !== id) {
          SurveyStore.pendingSurvey = { id };
        }
      }
    },
  },
  watch: {
    $route: function (route) {
      this.syncNavFromRoute(route);
    },
  },
  mounted() {
    if (!AuthUtil.isAuthenticated()) {
      AuthUtil.login();
    } else {
      UserInfoStore.fetch();
      OrgInfoStore.fetch();
      // Activate the nav item that matches the current URL on first load.
      this.syncNavFromRoute(this.$route);
    }
  },
};
</script>

<style scoped>
.main-container {
  position: absolute;
  width: calc(100% - 88px);
  height: 100%;
  left: 88px;
}

@media only screen and (max-width: 767px) {
  .main-container {
    position: absolute;
    width: 100%;
    height: calc(100% - 80px);
    left: 0;
    top: 0;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
